import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { SidemenuComponent } from "../../Components/Admin/Sidemenu"
import PromoCodesPage from "../../Components/Admin/AdminPromocodes"
const Adminaddpromo = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="10" xs="12" className="px-0" style={{ marginLeft: "17%" }}>
          <PromoCodesPage />
        </Col>
      </Row>
    </Container>
  )
}
export default Adminaddpromo
